/**
 * Utility function to get the correct document URL based on the source
 * Handles:
 * - External URLs (http/https)
 * - CMS uploaded documents (/uploads/)
 * - Local assets (/assets/)
 * 
 * @param {string} documentPath - The document path from database
 * @returns {string} - The resolved document URL
 */
export function getDocumentUrl(documentPath) {
  if (!documentPath) {
    return ''
  }

  // If it's a full URL (starts with http), return as-is
  if (documentPath.startsWith('http://') || documentPath.startsWith('https://')) {
    return documentPath
  }

  // Get CMS API URL from environment variable
  const CMS_API_URL = process.env.REACT_APP_CMS_API_URL || 'https://jriit.beetletz.online'
  
  // Remove /api/public if it's in the URL to get base URL
  const baseUrl = CMS_API_URL.replace('/api/public', '').replace(/\/$/, '')

  // If it's from CMS uploads folder, prepend CMS domain
  if (documentPath.startsWith('/uploads/') || documentPath.startsWith('uploads/')) {
    // Ensure path starts with /
    const normalizedPath = documentPath.startsWith('/') ? documentPath : `/${documentPath}`
    return `${baseUrl}${normalizedPath}`
  }
  
  // If it's a path that starts with / but isn't /assets/, it might be a CMS path
  // Check if it looks like a file path (has document extension)
  if (documentPath.startsWith('/') && !documentPath.startsWith('/assets/') && /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|rtf|txt)$/i.test(documentPath)) {
    return `${baseUrl}${documentPath}`
  }

  // If it's a local asset path, return as-is
  if (documentPath.startsWith('/assets/')) {
    return documentPath
  }

  // For any other path, return as-is
  return documentPath
}

